import React from 'react';
import Marker from 'src/presentation/components/molecules/Marker';
import { useMapStore, type MapHotspot } from 'src/domain/stores/useMapStore';

interface MarkersProps {
	color: string;
	pixels: {
		width: number;
		height: number;
	};
	canvasWidth: number;
	canvasHeight: number;
}

export default function Markers({ color, pixels, canvasWidth, canvasHeight }: MarkersProps) {
	const markerData = useMapStore.getState().hotspots;

	const scaleX = canvasWidth / pixels.width;
	const scaleY = canvasHeight / pixels.height;

	return markerData?.map((marker: MapHotspot) => {
		if (!marker.x || !marker.y) {
			return null;
		}

		return (
			<Marker
				color={color}
				data={{
					image: marker.image,
					title: marker.name,
					description: marker.description,
					pageID: marker.link ? marker.link.split('/') : undefined,
				}}
				key={marker.x * marker.y}
				x={marker.x * scaleX}
				y={marker.y * scaleY}
			/>
		);
	});
}
